import { useState } from "react";
import { ChevronDown, Send } from "lucide-react";
import { Button, Dropdown } from "../ui/index.js";

export const PayrollEmailMenu = ({
  disabled,
  sending,
  onChoose,
}: {
  disabled: boolean;
  sending: boolean;
  onChoose: (mode: "dry_run" | "live") => void;
}) => {
  const [mode, setMode] = useState<"dry_run" | "live">("dry_run");
  const unavailable = disabled || sending;
  return (
    <div
      role="group"
      aria-label="Payroll email"
      className="inline-flex max-w-full"
    >
      <Button
        type="button"
        size="md"
        variant="outline"
        className="min-h-11 min-w-0 rounded-r-none border-accent/30 bg-accent-subtle text-accent"
        disabled={unavailable}
        aria-busy={sending || undefined}
        onClick={() => onChoose(mode)}
      >
        <Send size={16} aria-hidden="true" />
        {sending
          ? "Sending…"
          : mode === "dry_run"
            ? "Run payroll email dry run"
            : "Send real payroll emails"}
      </Button>
      <Dropdown.Root>
        <Button
          type="button"
          size="md"
          variant="outline"
          iconOnly
          className="min-h-11 min-w-11 rounded-l-none border-l-0 border-accent/30 bg-accent-subtle text-accent"
          disabled={unavailable}
          aria-label="Payroll email options"
        >
          <ChevronDown size={16} aria-hidden="true" />
        </Button>
        <Dropdown.Popover
          placement="bottom end"
          className="payroll-email-menu border border-border bg-surface text-foreground"
        >
          <Dropdown.Menu
            aria-label="Payroll email delivery mode"
            selectionMode="single"
            selectedKeys={[mode]}
            onAction={(key: React.Key) =>
              setMode(key === "live" ? "live" : "dry_run")
            }
          >
            <Dropdown.Item id="dry_run" textValue="Dry run — send to office">
              Dry run — send to office
            </Dropdown.Item>
            <Dropdown.Item id="live" textValue="Real — send to employees">
              Real — send to employees
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown.Popover>
      </Dropdown.Root>
    </div>
  );
};
